//Import Facebook API Wrappers
import  { reply }  from "./reply"
import  { create }  from "./create"

//Export to use in Components
// api [type] [verb]
// EX: api.directMessage.reply
export default {
  api: {
    email: {
      reply,
      create
    }
  }
}


// WEBPACK FOOTER //
// ./src/libs/email/index.js